import {Api} from '@/api'

const permission = {
  state: {
    permissions: {},
    permissionsInited: false
  },
  mutations: {
    SET_PERMISSION: (state, permissions) => {
      state.permissions = permissions
      state.permissionsInited = true
    }
  },
  actions: {
    InitPermissions ({commit}) {
      Api.permission.permissionList().then(permissions => {
        commit('SET_PERMISSION', permissions)
      })
    }
  }
}

export default permission



// WEBPACK FOOTER //
// ./src/store/modules/permission.js